"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderWithMoreBtn = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Order = require("../Order");
var _LocaleProvider = require("../LocaleProvider");
var _Image = require("../Image");
var _arrow_right_red = _interopRequireDefault(require("../../assets/images/arrow_right_red.svg"));
var _arrow_right_gray = _interopRequireDefault(require("../../assets/images/arrow_right_gray.svg"));
var _Popup = require("../Popup");
var _ProductList = require("../ProductList");
var _constants = require("../../utils/constants");
var _useTracking = require("../../hooks/useTracking");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var PREFIX = (0, _getPrefixCls.getPrefixCls)('order-card-with-more-button');
var OrderWithMoreBtn = function OrderWithMoreBtn(props) {
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var title = props.title,
    order = props.order,
    _props$loadMoreOrderT = props.loadMoreOrderText,
    loadMoreOrderText = _props$loadMoreOrderT === void 0 ? trans('more_order_text') : _props$loadMoreOrderT,
    tabs = props.tabs,
    onLoadMore = props.onLoadMore,
    defaultSelected = props.defaultSelected,
    itemText = props.itemText,
    itemsText = props.itemsText,
    panelTitleText = props.panelTitleText,
    userTypes = props.userTypes,
    showUserTypeTab = props.showUserTypeTab,
    _onButtonClick = props.onButtonClick,
    componentTrackingData = props.componentTrackingData,
    _props$showLoading = props.showLoading,
    showLoading = _props$showLoading === void 0 ? true : _props$showLoading,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$showMoreButton = props.showMoreButton,
    showMoreButton = _props$showMoreButton === void 0 ? true : _props$showMoreButton,
    showOrderId = props.showOrderId,
    onClosePopup = props.onClosePopup;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var _useComponentTracking = (0, _useTracking.useComponentTracking)({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    orderCardTracking = _useComponentTracking2.orderCard,
    moreOrderTracking = _useComponentTracking2.moreOrder;
  var handleClosePopup = function handleClosePopup() {
    onClosePopup === null || onClosePopup === void 0 ? void 0 : onClosePopup();
    setShowPopup(false);
  };
  var handleMoreOrderClick = function handleMoreOrderClick() {
    if (disabled) {
      return;
    }
    setShowPopup(true);
    (moreOrderTracking === null || moreOrderTracking === void 0 ? void 0 : moreOrderTracking.trackingClick) && tracker.click(moreOrderTracking.trackingClick);
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: PREFIX
  }, orderCardTracking === null || orderCardTracking === void 0 ? void 0 : orderCardTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-btn-wrapper ").concat(disabled ? "".concat(PREFIX, "-btn-wrapper_disabled") : '')
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(PREFIX, "-btn-wrapper-title")
  }, title), showMoreButton ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    onClick: handleMoreOrderClick
  }, moreOrderTracking === null || moreOrderTracking === void 0 ? void 0 : moreOrderTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement("p", {
    className: "".concat(PREFIX, "-btn-wrapper-text")
  }, loadMoreOrderText), ' ', /*#__PURE__*/_react.default.createElement(_Image.Image, {
    src: disabled ? _arrow_right_gray.default : _arrow_right_red.default
  })) : null), /*#__PURE__*/_react.default.createElement(_Order.Order, order), /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    title: panelTitleText || trans(_constants.BUYER_ORDER_LIST_TITLE_TEXT),
    showCloseIcon: true,
    active: showPopup,
    onClose: function onClose() {
      return handleClosePopup();
    },
    titleClassName: "".concat(PREFIX, "-popup__title"),
    contentClassName: "".concat(PREFIX, "-popup__content")
  }, /*#__PURE__*/_react.default.createElement(_ProductList.ProductListTabs, {
    tabs: tabs,
    onLoadMore: onLoadMore,
    defaultSelected: defaultSelected,
    itemText: itemText,
    itemsText: itemsText,
    showOrderId: showOrderId,
    showUserTypeTab: showUserTypeTab,
    onButtonClick: function onButtonClick(params) {
      _onButtonClick === null || _onButtonClick === void 0 ? void 0 : _onButtonClick(params);
      setShowPopup(false);
    },
    userTypes: userTypes // trackingData={trackingData}
    ,

    componentTrackingData: componentTrackingData,
    showLoading: showLoading
  })));
};
exports.OrderWithMoreBtn = OrderWithMoreBtn;